"use client";

import React, { useCallback, useEffect, useState } from "react";

export const usePrevNextButtons = (emblaApi) => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
  }, [emblaApi]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback((emblaApi) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev());
    setNextBtnDisabled(!emblaApi.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect(emblaApi);
    emblaApi.on("reInit", onSelect);
    emblaApi.on("select", onSelect);
  }, [emblaApi, onSelect]);

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  };
};

export const PrevButton = (props) => {
  const { children, ...restProps } = props;

  return (
    <button
      className="embla__button embla__button--prev rotate-180 absolute top-1/2 left-2 lg:left-10 transform -translate-y-1/2"
      type="button"
      {...restProps}
    >
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="28"
          cy="28"
          r="28"
          fill="#FFB154"
          fillOpacity="0.8"
        ></circle>
        <path
          d="M37 28L29.2446 21L27.6023 22.4872L32.5454 26.9536L19 26.9536L19 29.0512L32.5454 29.0512L27.6023 33.5176L29.2446 35L37 28Z"
          fill="black"
        ></path>
      </svg>
    </button>
  );
};

export const NextButton = (props) => {
  const { children, ...restProps } = props;

  return (
    <button
      className="embla__button embla__button--next absolute top-1/2 right-2 lg:right-10 transform -translate-y-1/2"
      type="button"
      {...restProps}
    >
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="28"
          cy="28"
          r="28"
          fill="#FFB154"
          fillOpacity="0.8"
        ></circle>
        <path
          d="M37 28L29.2446 21L27.6023 22.4872L32.5454 26.9536L19 26.9536L19 29.0512L32.5454 29.0512L27.6023 33.5176L29.2446 35L37 28Z"
          fill="black"
        ></path>
      </svg>
    </button>
  );
};
